/* @refresh reset */
import React from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

import { Codeowners } from '../../consts/codeowners';

import { SomethingWentWrong } from './SomethingWentWrong';

type ErrorBoundaryProps = {
  children: React.ReactNode;
  fallback?: React.ReactElement;
  codeowners?: Codeowners | undefined;
  fingerprint?: string | string[] | undefined;
};

const ErrorBoundary = ({
  children,
  fallback = <SomethingWentWrong />,
  codeowners = Codeowners.CUSTOMER_INTAKE,
  fingerprint,
}: ErrorBoundaryProps) => (
  <SentryErrorBoundary
    fallback={fallback}
    beforeCapture={(scope) => {
      if (codeowners) {
        scope.setTag('codeowners', codeowners);
      }

      if (fingerprint) {
        scope.setFingerprint(Array.isArray(fingerprint) ? fingerprint : [fingerprint]);
      }

      scope.setTag('error_boundary', 'true');
    }}
  >
    {children}
  </SentryErrorBoundary>
);

export default ErrorBoundary;
